import { vueData } from '@/VueData';
import type { useRestaurantStore } from '@/stores/restaurant.store';
import { timeInsideHours } from '@/utils';
import type { IGpthelpVisibilityCtx } from './menu/gpthelp-admin-menu-visibility';
import type { IGpthelpTaxCtx } from './menu/gpthelp-admin-menu-pricing';

type IRestaurantStore = ReturnType<typeof useRestaurantStore>;

export function buildGpthelpVisibilityCtx(params: {
  restaurantStore: IRestaurantStore;
}): IGpthelpVisibilityCtx {
  const { restaurantStore } = params;

  const selectedBranch = restaurantStore.selectedBranch;
  const branchTz = selectedBranch?.location?.tz ?? null;
  const hoursEnforced = restaurantStore.effectiveTier > 0 && !!branchTz;

  return {
    branchIdStr: selectedBranch ? String(selectedBranch.id) : null,
    hoursEnforced,
    isInsideHours:
      hoursEnforced && branchTz
        ? (ranges) => timeInsideHours(ranges, branchTz)
        : () => true,
  };
}

export function buildGpthelpTaxCtx(params: {
  restaurantStore: IRestaurantStore;
}): IGpthelpTaxCtx {
  const restaurant = params.restaurantStore.restaurant;
  const settings = restaurant?.settings ?? vueData.restaurantSettings ?? null;

  return {
    taxPercent: typeof restaurant?.tax === 'number' ? restaurant.tax : null,
    taxMode: settings?.taxMode ?? null,
  };
}
